import axios from "axios";
import store from "../../store";
import customModal from "../customModal/customModal.vue";
import Multiselect from "@vueform/multiselect";

export default {
  name: "ArmModal",
  components: { customModal, Multiselect },
  props: { editingId: String },
  emits: ["closeModal", "saved", "refreshCraList"],

  data() {
    return {
      baseurl: process.env.VUE_APP_Service_URL,
      token: "",
      // isEditMode: false,
      studyId: "",

      roleList: [],
      userList: [],
      sites: [],
      visitTypes: [],
      checklists: [],

      craDetails: {
        roleId: "",
        craEmail: ""
      },

      newCra: {
        siteId: "",
        plannedDate: "",
        endDate: "",
        visitType: "",
        checklistId: "",
        monitoringMode: "",
        triggeredBy: "",
        unit: "",
        value: "",
        status: "Planned",
        checklist: [],
        visitName: "",
        Comment: "",

      },
      checklist: "",

      formErrors: {},
      loading: true,


      monitoringModeOptions: ["Onsite", "Remote", "Hybrid", "Central"],
      triggeredByOptions: [
        "Protocol Scheduled",
        "Risk Signal Detected",
        "Major Protocol Deviation",
        "High Query Rate",
        "High AE Rate",
        "Missed Visit",
        "Manual Assignment",
        "Regulatory Requirement",
        "Others"
      ]
    };
  },

  async mounted() {
    this.token = store.getters.getIdToken;
    this.studyId = store.getters.getStudyIs;

    await this.setRoleList();

    if (this.editingId) {
      await this.fetchCraScheduleById();
    } else {
      await Promise.all([
        this.onRoleChange(),
        this.getsites(),
        this.getVisitTypes()
      ]);
    }
  },

  computed: {
    craRoleId() {
      const craRole = this.roleList.find(
        r => r.roleName?.toUpperCase() === "CRA"
      );
      return craRole?.roleID || "";
    },
    showRepeatPeriod() {
    return (
      !this.editingId  &&
      this.newCra.visitType === "Site Monitoring"
    );
  },
    selectedVisitType() {
    return this.visitTypes.find(
      t => t.id === this.newCra.visitType
    )?.type;
  }
  },



  methods: {
    closeModal() {
      this.$emit("closeModal");
    },

    async setRoleList() {
      const res = await axios.get(
        `${this.baseurl}/account-core/roles/rolelist`,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );
      this.roleList = res.data || [];
    },
   async fetchCraScheduleById() {
  try {
    const { data } = await axios.get(
      `${this.baseurl}/forms/cra/getbyid`,
      {
        params: { id: this.editingId },
        headers: { Authorization: `Bearer ${this.token}` }
      }
    );

    if (!data) return;
    this.craDetails.craEmail = data.craId;
    this.newCra.plannedDate = data.plannedDate?.substring(0, 10) || "";
    this.newCra.status = data.status || "Planned";
    this.newCra.monitoringMode = data.monitoringMode || "";
    if (!this.userList.length) {
      await this.onRoleChange();
    }

  } catch (err) {
    console.error("Failed to load CRA schedule", err);
  }
},

    async getRoleIdByEmail(email) {
      const res = await axios.get(
        `${this.baseurl}/account-core/user/userlist`,
        {
          params: {
            Key: email,
            pageindex: 1,
            pagesize: 1
          },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );

      const roleName = res.data?.results?.[0]?.role?.[0];
      const role = this.roleList.find(r => r.roleName === roleName);
      return role?.roleID || "";
    },



    async onRoleChange() {
      if (!this.craRoleId) {
        console.warn("CRA role not found");
        return;
      }

      console.log("CRA Role ID:", this.craRoleId);

      if (!this.editingId) {
        this.craDetails.craEmail = "";
      }

      const res = await axios.get(
        `${this.baseurl}/account-core/user/getusersbyrole`,
        {
          params: {
            roleids: this.craRoleId,
            studyid: this.studyId
          },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );

      this.userList = res.data || [];
    },



    async getsites() {
      const res = await axios.get(
        `${this.baseurl}/management/site/getall`,
        {
          params: { studyId: this.studyId },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );
      this.sites = res.data || [];
    },

    async getVisitTypes() {
      const res = await axios.get(
        `${this.baseurl}/forms/cra/getcravisittype`,
        {   params: { studyId: this.studyId },
          headers: { Authorization: `Bearer ${this.token}` } }
      );
      this.visitTypes = res.data || [];
    },

    async onVisitTypeChange() {
      console.log("Selected Visit Type:", this.newCra.visitType);
      let studyId = store.getters.getStudyIs;
      this.newCra.checklist = [];
      this.checklists = [];

      if (!this.newCra.visitType) return;

      const res = await axios.get(
        `${this.baseurl}/forms/cra/getchecklistbyvisit`,
        {
          params: { visitId: this.newCra.visitType, studyId : studyId },
          headers: { Authorization: `Bearer ${this.token}` }
        }
      );

    this.checklists = (res.data?.checklist || []).map(item => ({
    value: item.checklistId,
    label: item.title,
    questions: item.questions
  }));
    },
    validateForm() {
      this.formErrors = {};

      if (!this.craDetails.craEmail) {
        this.formErrors.cra = "CRA is required";
      }

      if (!this.newCra.siteId) {
        this.formErrors.sites = "Site is required";
      }

      if (!this.newCra.plannedDate) {
        this.formErrors.plannedDate = "Planned date is required";
      }

      return Object.keys(this.formErrors).length === 0;
    },

    async submitCraSchedule() {
      if (!this.validateForm()) {
        return;
      }

      const userEmail = store.getters.getUserEmail;
      const userId = store.getters.getUserId;
      const now = new Date().toISOString();

      const selectedSite = this.sites.find(
        s => s.siteID === this.newCra.siteId
      );
      const selectedVisitType = this.visitTypes.find(
        v => v.id === this.newCra.visitType
      );


      const payload = {

        studyId: this.studyId,
        craId: this.craDetails.craEmail,
        siteId: selectedSite?.siteID || "",
        siteCode: selectedSite?.siteCode || "",

        craVisitTypeId: selectedVisitType?.id || "",
        craVisitType: selectedVisitType?.type || "",
        visitName: this.newCra.visitName || "",
        monitoringMode: this.newCra.monitoringMode,

        plannedDate: new Date(this.newCra.plannedDate).toISOString(),
        actualDate: null,

        status: this.newCra.status || "Planned",
        reason: this.newCra.triggeredBy || "",
        comments: this.newCra.triggeredBy === 'Others' ? this.newCra.Comment : '',

        immediateDate: new Date(this.newCra.plannedDate).toISOString(),
        overridePlannedDate: false,

        checklist: this.newCra.checklist && this.newCra.checklist.length > 0
          ? this.newCra.checklist
          : [],

        endDate: this.newCra.endDate
          ? new Date(this.newCra.endDate).toISOString()
          : null,


        repeatPeriod: {
          value: Number(this.newCra.value || 0),
          unit: this.newCra.unit || ""
        }
      };

      await axios.post(
        `${this.baseurl}/forms/cra/craschedulecreate`,
        // `https://localhost:5002/cra/craschedulecreate`,
        payload,
        { headers: { Authorization: `Bearer ${this.token}` } }
      );
alert("CRA schedule created successfully");
      this.$emit("saved");
      this.$emit("refreshCraList");
      this.closeModal();
    },
async updateCraSchedule() {
  this.formErrors = {};

  if (!this.craDetails.craEmail) {
    this.formErrors.cra = "CRA is required";
  }
  if (!this.newCra.plannedDate) {
    this.formErrors.plannedDate = "Planned date is required";
  }
  if (!this.newCra.status) {
    this.formErrors.status = "Status is required";
  }
 if (!this.newCra.monitoringMode) {
    this.formErrors.monitoringMode = "Monitoring mode is required";
  }
  if (Object.keys(this.formErrors).length > 0) return;

  const payload = {
    craId: this.craDetails.craEmail,
    craScheduleId: this.editingId,
    plannedDate: new Date(this.newCra.plannedDate).toISOString(),
    status: this.newCra.status,
    monitoringMode: this.newCra.monitoringMode
  };

  try {
    await axios.put(
      `${this.baseurl}/forms/cra/crascheduleupdate`,
      payload,
      { headers: { Authorization: `Bearer ${this.token}` } }
    );

    this.$emit("saved");
    this.$emit("refreshCraList");
    this.closeModal();

    alert("CRA schedule updated successfully"); 
  } catch (err) {
    console.error("Failed to update CRA schedule", err);
    alert("Failed to update CRA schedule"); 
  }
}





    // async submitAllCra() {
    //   if (!this.craDetails.roleId || !this.craDetails.craEmail) {
    //     alert("Role and CRA are required");
    //     return;
    //   }

    //   const payload = {
    //     craId: this.craDetails.craEmail,
    //     studies: [{
    //       studyId: this.studyId,
    //       sites: [{
    //         siteId: this.newCra.siteId,
    //         plannedDate: new Date(this.newCra.plannedDate).toISOString(),
    //         repeatPeriod: {
    //           unit: this.newCra.unit,
    //           value: Number(this.newCra.value)
    //         }
    //       }]
    //     }]
    //   };

    //   await axios.post(
    //     `${this.baseurl}/forms/cra/assigncra`,
    //     payload,
    //     { headers: { Authorization: `Bearer ${this.token}` } }
    //   );

    //   this.$emit("saved");
    //   this.$emit("refreshCraList");
    //   this.closeModal();
    // }
  }
};
